import { useLayoutEffect } from 'react';

export const useShadow = (scene, castShadow = true, receiveShadow = true ) => {
  useLayoutEffect(() => {
    scene?.traverse(node => {
      if (node.isMesh) {
        node.castShadow = castShadow;
        node.receiveShadow = receiveShadow;
      }
    });
  }, [scene])
};
